/**
 * Sanitizes text to match SafeTextSchema validation rules.
 * Removes any characters that are not allowed by the EHR text validation pattern.
 *
 * Allowed characters: a-z, A-Z, 0-9, spaces, and special characters:
 * ~`!@#$%^&*()-_+={[}]|\;:–'",<>./?
 * Also allows newlines (\n), tabs (\t), and carriage returns (\r)
 */

// This regex matches the allowed characters from SafeTextSchema
const ALLOWED_CHARS_PATTERN = /[\w\t\n\r !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~–-]/g;

/**
 * Sanitizes text by removing characters that don't match SafeTextSchema validation
 * @param text - The text to sanitize
 * @returns Sanitized text with only allowed characters
 */
export function sanitizeText(text: string | undefined | null): string {
  if (!text) {
    return '';
  }

  // Extract all allowed characters and join them back together
  const matches = text.match(ALLOWED_CHARS_PATTERN);
  return matches ? matches.join('') : '';
}
